import { MdClose } from 'react-icons/md';
import { forwardRef } from 'react';
import { getScoreColor } from 'utils/helpers';
import styled from 'styled-components';

const FilterButton = styled.button.attrs(({ type = 'button' }) => ({
    type,
}))`
    border: solid 1px transparent;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 2px 8px;
    border-radius: 100px;
    color: ${({ theme }) => theme.gray_7};
    font-weight: ${({ theme }) => theme.fontSemiBold};
    font-size: ${({ theme }) => theme.fontSize_sm};
    font-family: ${({ theme }) => theme.style_primary};
    line-height: ${({ theme }) => theme.fontSize_base};
    letter-spacing: 0em;
    text-transform: capitalize;
    background-color: ${({ theme, ...props }) =>
        props.hasOwnProperty('score')
            ? getScoreColor(props.score, false, props.metricLabel)
            : theme.purple_1};
    cursor: pointer;
    ${({ $maxWidth }) => $maxWidth && `max-width: ${$maxWidth};`}

    &:hover {
        background-color: ${({ theme, ...props }) =>
            props.hasOwnProperty('score')
                ? getScoreColor(props.score, true, props.metricLabel)
                : theme.purple_2};
    }
`;

export const RemoveFilterButton = forwardRef(({ children, ...props }, ref) => (
    <FilterButton {...props} ref={ref}>
        {children}
        <MdClose css="margin-left: 6px; font-size: 14px;" />
    </FilterButton>
));

export default FilterButton;
